/**
 * Publication restrictions.
 * 'true' means it is restricted.
 */
interface IPublicationContentRestrictions {
    anonymousContentRestricted: boolean;
    blogging: boolean;
    comments: boolean;
    emailSharing: boolean;
    readItLater: boolean;
    smartFlow: boolean;
    sound: boolean;
    translation: boolean;
}

/**
 * Issue restrictions.
 * 'true' means it is restricted.
 */
interface IssueContentRestrictions {
    /** Blackout View */
    blackout: boolean;
    blogging: boolean;
    comments: boolean;
    copy: boolean;
    customPages: boolean;
    emailSharing: boolean;
    firstPageVisibilityIfIssueCouldNotBeRead: boolean;
    onlineAreaPrinting: boolean;
    onlineArticlePrinting: boolean;
    onlinePagePrinting: boolean;
    readItLater: boolean;
    replica: boolean;
    smartFlow: boolean;
    /** Shadow View */
    smartFlowIfIssueCouldNotBeRead: boolean;
    sound: boolean;
    translation: boolean;
}

const defaultPublicationContentRestrictions = Object.freeze<IPublicationContentRestrictions>({
    anonymousContentRestricted: false,
    blogging: false,
    comments: false,
    emailSharing: false,
    readItLater: false,
    smartFlow: false,
    sound: false,
    translation: false,
});

const defaultIssueContentRestrictions = Object.freeze<IssueContentRestrictions>({
    blackout: false,
    blogging: false,
    comments: false,
    copy: false,
    customPages: false,
    emailSharing: false,
    firstPageVisibilityIfIssueCouldNotBeRead: false,
    onlineAreaPrinting: false,
    onlineArticlePrinting: false,
    onlinePagePrinting: false,
    readItLater: false,
    replica: false,
    smartFlow: false,
    smartFlowIfIssueCouldNotBeRead: false,
    sound: false,
    translation: false,
});

export { defaultIssueContentRestrictions, defaultPublicationContentRestrictions, IPublicationContentRestrictions, IssueContentRestrictions };
